import React from "react";
import {cx} from "../../../lib/ClassSet";
import "./OtherPalletItem.css";

const OtherPalletItem = (props) => {

  let {data} = props;

  let classes = cx({
    "item": true,
    "inventory-pallet-list-item": true,
    "u-selected": props.selected
  })

  return (
    <tr className={classes} onClick={(e) => props.onClick(data, e)}>
      <td className="field f-id">{data.get("palletId")}</td>
      <td className="field f-sku">{data.get("sku")}</td>
      <td className="field f-state">{data.get("state")}</td>
      <td className="field f-quantity">{data.get("quantity")}</td>
    </tr>
  )
}

export default OtherPalletItem;